export default __webpack_public_path__ + "media/mwua-logo.dc525a5b.png";